// App.tsx
import { Navigate, Route, Routes } from "react-router-dom";
import NotFoundPage from "./pages/NotFoundPage";
import RedirectPage from "./pages/auth/RedirectPage";
import DeniedPage from "./pages/auth/DeniedPage";
import ScrollToTop from "./components/ui/ScrollToTop";
import { initCustomAlerts } from "./helpers/alertError";
import LoginPage from "./pages/auth/LoginPage";
import AgentProtectedNav from "./navigation/protected/AgentNav";
import EntrepriseProtectedNav from "./navigation/protected/EntrepriseNav";
import AcceptInvitationPage from "./pages/auth/AccepteInvitationPage";
import RegisterPage from "./pages/auth/RegisterPage";
import { LandingPage } from "./pages/public/LandingPage";
import AboutPage from "./pages/public/AboutPage";
import BlogPage from "./pages/public/BlogPage";
import FaqPage from "./pages/public/FaqPage";
import CareersPage from "./pages/public/CareersPafge";
import FeaturesPage from "./pages/public/FeaturesPage";
import ContactPage from "./pages/public/ContactPage";
import ResourcesPage from "./pages/public/RessourcesPage";
import SolutionsPage from "./pages/public/SolutionsPage";
import PricingPage from "./pages/public/PricingPage";
import CompanyInfoPage from "./pages/auth/CompanyInfoPage";
import CheckoutPage from "./pages/auth/CheckoutPage";
import { useEffect } from "react";
import PublicTicketNav from "./navigation/public/PublicTicketNav";
import usePushSubscription from "./hooks/core/usePushSubscription";
import useAuth from "./hooks/features/auth/useAuth";
import useNotificationActions from "./hooks/core/useNotificationActions";
import AdminProtectedNav from "./navigation/protected/AdminNav";
import VerifyOtpPage from "./pages/auth/OtpPage";
import PublicCallNav from "./navigation/public/PublicCallNav";
import MtnTests from "./pages/TestAPIPage";

function App() {
  initCustomAlerts();

  const { user } = useAuth();
  const agentId = user?.profile?.id;

  // Initialise l'abonnement push
  useNotificationActions();

  // Service Worker
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/js/sw.js")
        .then((registration) => {
          // console.log('✅ Service Worker enregistré');
        })
        .catch((error) => {
          //console.error('❌ Erreur SW:', error);
        });
    }
  }, []);

  return (
    <>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/carrieres" element={<CareersPage />} />
          <Route path="/fonctionnalites" element={<FeaturesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/ressources" element={<ResourcesPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/pricing" element={<PricingPage />} />

          <Route path="/ticket/*" element={<PublicTicketNav />} />
          <Route path="/call/*" element={<PublicCallNav />} />

          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/confirm-account" element={<VerifyOtpPage />} />

          <Route path="/company-infos" element={<CompanyInfoPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />

          <Route path="/redirect" element={<RedirectPage />} />
          <Route path="/denied" element={<DeniedPage />} />
          <Route path="/accept-invitation" element={<AcceptInvitationPage />} />

          <Route path="/admin/*" element={<AdminProtectedNav />} />
          <Route path="/entreprise/*" element={<EntrepriseProtectedNav />} />
          <Route path="/agent/*" element={<AgentProtectedNav />} />

          <Route path="/test-mtn" element={<MtnTests />} />

          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </ScrollToTop>
    </>
  );
}

export default App;
